module.exports = __webpack_public_path__ + "img/sidebar-button-active.08c7bb3.webp";